module.exports = __webpack_public_path__ + "static/media/test15_3.c5832862.png";